import React, { useEffect, useState } from "react";
import { Typography, Slider, Grid, Box } from '@mui/material';
import ModalFooter from "../../../Modal/ModalFooter/ModalFooter";

export default function StepFour(props) {
    const [buttons, setButtons] = useState(
        [
            {
                'function': props.prev,
                'text': 'Précedent',
                'disabled': false,
                'color': 'error'
            },
            {
                'function': props.next,
                'text': 'Suivant',
                'disabled': true,
                'color': 'success'
            }
        ]);

    const marks = [
        {
            value: 0,
            label: 'Sans avis',
        },
        {
            value: 5,
            label: 'de temps en temps',
        },
        {
            value: 10,
            label: 'En majorité',
        }
    ];

    useEffect(() => {
        if (props.datas.periodRent && Object.keys(props.datas.periodRent).length >= 4) {
            buttons[1].disabled = false;
        } else {
            buttons[1].disabled = true;
        }
        setButtons([...buttons]);
    }, [props.datas]);

    function handleChange(e) {
        let datas = Object.assign({}, props.datas);
        if(!datas.periodRent){
            datas.periodRent = {};
        }
        datas.periodRent[e.target.name] = e.target.value;
        props.handleChange(datas);
    }

    return (
        <>
            <Typography id="modal-modal-description" variant="p">
                Selon vous, à quelles périodes de l’année se font les « locations de logements à court et moyen terme» à Montpellier et ses environs ?
            </Typography>
            <Grid container spacing={2} justifyContent='center' direction='row'>
                <Grid item xs={9} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        Principalement pendant la saison estivale
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs>
                            <Slider
                                aria-label="Temperature"
                                defaultValue={props.datas.periodRent && props.datas.periodRent['summer'] ? props.datas.periodRent['summer'] : 5}
                                valueLabelDisplay="auto"
                                step={1}
                                marks={marks}
                                min={0}
                                max={10}
                                name='summer'
                                onChange={(e) => handleChange(e)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={9} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        En dehors de la saison estivale
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs>
                            <Slider
                                aria-label="Temperature"
                                defaultValue={props.datas.periodRent && props.datas.periodRent['outSummer'] ? props.datas.periodRent['outSummer'] : 5}
                                valueLabelDisplay="auto"
                                step={1}
                                marks={marks}
                                min={0}
                                max={10}
                                name='outSummer'
                                onChange={(e) => handleChange(e)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={9} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        Durant les vacances scolaires
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs>
                            <Slider
                                aria-label="Temperature"
                                defaultValue={props.datas.periodRent && props.datas.periodRent['holidays'] ? props.datas.periodRent['holidays'] : 5}
                                valueLabelDisplay="auto"
                                step={1}
                                marks={marks}
                                min={0}
                                max={10}
                                name='holidays'
                                onChange={(e) => handleChange(e)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={9} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        Le weekend
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs>
                            <Slider
                                aria-label="Temperature"
                                defaultValue={props.datas.periodRent && props.datas.periodRent['weekend'] ? props.datas.periodRent['weekend'] : 5}
                                valueLabelDisplay="auto"
                                step={1}
                                marks={marks}
                                min={0}
                                max={10}
                                name='weekend'
                                onChange={(e) => handleChange(e)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <ModalFooter buttons={buttons} />
        </>
    )
}